import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { ForensicMotif } from './ui/ForensicMotif';
export function GuaranteeSection() {
  return <section className="relative isolate overflow-hidden bg-navy py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-74" data-mp="9umi0wj5pw9e">
      <ForensicMotif side="right" data-id="element-75" data-mp="etpomlescajh" />
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-76" data-mp="ev0oia540y5b">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-3xl border-2 border-gold/50 bg-navy-light/70 p-8 shadow-2xl shadow-black/40 sm:p-12" data-id="element-77" data-mp="jt276tymivg9">
          <span className="inline-flex rounded-full border border-gold/60 bg-navy p-4 text-gold" data-id="element-78" data-mp="xm1lwtql0lmr">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-79" data-mp="12gxj08aodz6q" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-balance text-3xl font-extrabold uppercase tracking-tight text-ivory sm:text-4xl" data-id="element-80" data-mp="17id1bslgxrlf">
            Garanzia di soddisfazione <span className="text-gold" data-id="element-81" data-mp="20rsrsv0znv7p">di 7 giorni</span>
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-ivory/80" data-id="element-82" data-mp="1vthg0er4vamu">
            Se entro 7 giorni il materiale non fa per te,{' '}
            <span className="font-extrabold text-gold" data-id="element-83" data-mp="1rt79n0zfii7g">ti rimborsiamo. Senza domande.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}